import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common';
import { LibColor } from '../colors/colors-map';
import { mediumThinX } from '../../../icons/processed';
import { Icon } from '../../../primitives/icon/icon';
import * as Color from 'color';
import { getIdealTextColor } from '@wix/answers-lib';
export var labelKey = 'label-container';
var defaultLabelProps = {
    type: 'primary',
};
var defaultBackgroundColor = {
    primary: LibColor.sky120,
    secondary: LibColor.white,
};
var defaultTextColor = {
    primary: LibColor.dark30,
    secondary: LibColor.grey50,
};
var Label = /** @class */ (function (_super) {
    __extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Label.prototype.render = function () {
        var props = __assign(__assign({}, defaultLabelProps), this.props);
        var backgroundColor = props.color || defaultBackgroundColor[props.type];
        var hoverBackgroundColor = props.hoverColor || backgroundColor;
        var borderColor = props.borderless ? backgroundColor : (props.borderColor || Color(backgroundColor).darken(0.05));
        var textColor = getIdealTextColor(backgroundColor, defaultTextColor[props.type], LibColor.white);
        // tslint:disable:no-object-literal-type-assertion
        var style = {
            '--var-color': backgroundColor,
            '--var-hover-color': hoverBackgroundColor,
            border: "1px solid " + borderColor,
            color: textColor,
            cursor: props.onClick ? 'pointer' : 'inherit',
            '--var-text-color': textColor,
            '--var-font-size': props.size === 'small' || props.size === 'tiny' ? '12px' : '14px',
        };
        var iconStyle = { '--var-color': textColor };
        var classnames = namespacedClassnames(labelKey, props.className, props.size);
        var removeIcon = (React.createElement("div", { className: 'remove-icon', onMouseDown: props.onRemove, style: iconStyle },
            React.createElement(Icon, { icon: mediumThinX })));
        return (React.createElement("div", { className: classnames, style: style, onClick: props.onClick },
            props.children,
            props.onRemove ? removeIcon : null));
    };
    return Label;
}(React.PureComponent));
export { Label };
//# sourceMappingURL=index.js.map